module.exports = __webpack_public_path__ + "ab2078234be946144c2a42e66ddca31d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/zhizhao.png
// module id = 1272
// module chunks = 61